import * as React from 'react';
import { BaSeTheme } from '@base/react';
import { DeleteInfo } from '../../../components/product/modal/delete';

const ACTIONS = {
  CONFIRM_DELETE: 'Sim, confirmar exclusão',
  CANCEL_DELETE: 'Não, cancelar exclusão',
};

export const useProductModals = (onDelete, showModal, showNotification) => {
  const handleDeleteAction = React.useCallback(
    async (action, produto) => {
      if (action === ACTIONS.CONFIRM_DELETE) {
        const result = await onDelete(produto.id);
        if (result.sucess) {
          showNotification({
            message: 'Registro excluído com sucesso!',
            color: 'confirmation',
          });
        } else {
          showNotification({
            message: 'Erro ao excluir produto',
            color: 'destructive',
          });
        }
        return result;
      }
      return true;
    },
    [onDelete, showNotification],
  );

  const showDeleteModal = React.useCallback(
    (produto) => {
      const modalConfig = {
        size: 'large',
        title: 'Atenção!',
        actions: [
          ACTIONS.CONFIRM_DELETE,
          {
            action: ACTIONS.CANCEL_DELETE,
            type: 'secondary',
            color: BaSeTheme.colors.institucionais.azulSebrae36,
          },
        ],
        onChooseAction: (action) => handleDeleteAction(action, produto),
        content: (onClose) => React.cloneElement(<DeleteInfo />, { onClose }),
      };
      showModal(modalConfig);
    },
    [handleDeleteAction, showModal],
  );

  return {
    showDeleteModal,
  };
};
